// 30523

import React, { useState } from 'react';
import useAuth from '../../hooks/useAuth';
import Loader from '../../components/Loader/Loader';
import Select from 'react-select';
import './DistributorLookup.css';
// import distributorData from './data.json';
import distributorData from './data_with_coords.json';
import uszips from './uszips.json';
import { filterDistributorsByRadius } from '../../utils/geoUtils';

const DistributorLookupPage = () => {
    const { user } = useAuth();

    const [selectedState, setSelectedState] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    const [zipCode, setZipCode] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [dataArray, setDataArray] = useState([]);
    const [hasSearched, setHasSearched] = useState(false); // ⭐ important

    const stateOptions = [
        { label: 'Alabama', value: 'AL' },
        { label: 'Alaska', value: 'AK' },
        { label: 'Arizona', value: 'AZ' },
        { label: 'Arkansas', value: 'AR' },
        { label: 'California', value: 'CA' },
        { label: 'Colorado', value: 'CO' },
        { label: 'Connecticut', value: 'CT' },
        { label: 'Delaware', value: 'DE' },
        { label: 'Florida', value: 'FL' },
        { label: 'Georgia', value: 'GA' },
        { label: 'Hawaii', value: 'HI' },
        { label: 'Idaho', value: 'ID' },
        { label: 'Illinois', value: 'IL' },
        { label: 'Indiana', value: 'IN' },
        { label: 'Iowa', value: 'IA' },
        { label: 'Kansas', value: 'KS' },
        { label: 'Kentucky', value: 'KY' },
        { label: 'Louisiana', value: 'LA' },
        { label: 'Maine', value: 'ME' },
        { label: 'Maryland', value: 'MD' },
        { label: 'Massachusetts', value: 'MA' },
        { label: 'Michigan', value: 'MI' },
        { label: 'Minnesota', value: 'MN' },
        { label: 'Mississippi', value: 'MS' },
        { label: 'Missouri', value: 'MO' },
        { label: 'Montana', value: 'MT' },
        { label: 'Nebraska', value: 'NE' },
        { label: 'Nevada', value: 'NV' },
        { label: 'New Hampshire', value: 'NH' },
        { label: 'New Jersey', value: 'NJ' },
        { label: 'New Mexico', value: 'NM' },
        { label: 'New York', value: 'NY' },
        { label: 'North Carolina', value: 'NC' },
        { label: 'North Dakota', value: 'ND' },
        { label: 'Ohio', value: 'OH' },
        { label: 'Oklahoma', value: 'OK' },
        { label: 'Oregon', value: 'OR' },
        { label: 'Pennsylvania', value: 'PA' },
        { label: 'Rhode Island', value: 'RI' },
        { label: 'South Carolina', value: 'SC' },
        { label: 'South Dakota', value: 'SD' },
        { label: 'Tennessee', value: 'TN' },
        { label: 'Texas', value: 'TX' },
        { label: 'Utah', value: 'UT' },
        { label: 'Vermont', value: 'VT' },
        { label: 'Virginia', value: 'VA' },
        { label: 'Washington', value: 'WA' },
        { label: 'West Virginia', value: 'WV' },
        { label: 'Wisconsin', value: 'WI' },
        { label: 'Wyoming', value: 'WY' }
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedState && !zipCode) {
            setErrorMessage('Please select a state or enter a ZIP code to search.');
            return;
        }

        setHasSearched(true); // ⭐ trigger results
        setShowLoader(true);
        setErrorMessage('');

        const startTime = Date.now();

        try {
            let results = [];

            if (selectedState) {
                results = distributorData.filter(
                    (d) => d.state === selectedState.value
                );
            } else if (zipCode) {
                const trimmedZip = zipCode.trim();

                // Find ZIP coordinates
                const zipData = uszips.find(
                    (z) => z.zip === trimmedZip
                );

                if (!zipData) {
                    setErrorMessage('Invalid ZIP code.');
                    setDataArray([]);
                    setShowLoader(false);
                    return;
                }

                // Exact ZIP matches
                const directMatch = distributorData.filter(
                    (d) => d.zip_code === trimmedZip
                );

                // Radius search
                const nearbyResults = filterDistributorsByRadius(
                    Number(zipData.lat),
                    Number(zipData.long),
                    distributorData,
                    100
                );

                // Remove duplicates
                const existingEmails = new Set(
                    directMatch.map((d) => d.email)
                );

                const uniqueNearby = nearbyResults.filter(
                    (d) => !existingEmails.has(d.email)
                );

                results = [...directMatch, ...uniqueNearby];

                console.log(results);
            }
          

            const elapsed = Date.now() - startTime;
            const delay = Math.max(2000 - elapsed, 0);

            setTimeout(() => {
                setDataArray(results);
                setShowLoader(false);
            }, delay);

        } catch (error) {
            console.error(error);
            setShowLoader(false);
        }
    };

    const handleStateChange = (option) => {
        setSelectedState(option);
        setZipCode('');
        setErrorMessage('');
        setHasSearched(false); // reset
    };

    const handleZipChange = (e) => {
        setZipCode(e.target.value);
        setSelectedState(null);
        setHasSearched(false); // reset
    };

    const renderMessageBox = (title, message) => (
        <div className="text-center my-5 fade-in">
            <div className="p-5 rounded-3 shadow-sm bg-light border d-inline-block">
                <h3 className="fw-bold text-dark">{title}</h3>
                <p className="text-muted mb-0">{message}</p>
            </div>
        </div>
    );

    const renderDefaultMessage = () =>
        renderMessageBox(
            'Search Distributor',
            <>Please select a state or enter a ZIP code and click "Find Distributor".</>
        );

    const renderNoDataFound = () =>
        renderMessageBox(
            'Data not found',
            <>
                {selectedState && (
                    <span className="fw-semibold">
                        No results for {selectedState.label} ({selectedState.value})
                    </span>
                )}
                {zipCode && (
                    <span className="fw-semibold d-block mt-2">
                        No results for ZIP code {zipCode}
                    </span>
                )}
                <div className="mt-2">Please try a different selection.</div>
            </>
        );

    const renderResults = () => (
        <div className="map-lookup-map-detail">
            <div className="distributor-results-grid">
                {dataArray.map((item) => (
                    <div key={item.id || item.email} className="distributor-card">
                        <div className="distributor-card-title">{item.name}</div>

                        <div className="distributor-card-detail">
                            <div className="distributor-info-item">
                                <strong>Address:</strong> {item.full_address}
                            </div>
                            <div className="distributor-info-item">
                                <strong>City:</strong> {item.city}
                            </div>
                            <div className="distributor-info-item">
                                <strong>State:</strong> {item.state}
                            </div>
                            <div className="distributor-info-item">
                                <strong>Zip Code:</strong> {item.zip_code}
                            </div>
                            <div className="distributor-info-item">
                                <strong>Phone:</strong>{' '}
                                <a href={`tel:${item.phone}`}>{item.phone}</a>
                            </div>
                            <div className="distributor-info-item">
                                <strong>Email:</strong>{' '}
                                <a href={`mailto:${item.email}`}>{item.email}</a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <main className="techtop-middle-div">
            <section className="techtop-quote-section pb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="techtop-default-title2">

                                {/* HEADER */}
                                <div className="row">
                                    <div className="col-6">
                                        <h1>Distributor Lookup</h1>
                                    </div>
                                    <div className="col-6 text-end">
                                        <h2>{user?.name || ''}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* FORM */}
                    <form onSubmit={handleSubmit}>
                        <div className="row mt-3 map-lookup-div">

                            <div className="col-md-4">
                                <Select
                                    options={stateOptions}
                                    placeholder="Select State"
                                    value={selectedState}
                                    onChange={handleStateChange}
                                />
                            </div>

                            <div className="col-md-4">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter ZIP code"
                                    value={zipCode}
                                    onChange={handleZipChange}
                                />
                            </div>

                            <div className="col-md-4">
                                <button className="find-my-rep-btn w-100">
                                    Find Distributor
                                </button>
                            </div>

                            {errorMessage && (
                                <div className="text-danger text-center mt-2">
                                    {errorMessage}
                                </div>
                            )}
                        </div>
                    </form>

                    {/* RESULTS */}
                    <div className="row mt-4">
                        <div className="col-md-12">
                            {!showLoader && (
                                hasSearched ? (
                                    dataArray.length > 0
                                        ? renderResults()
                                        : renderNoDataFound()
                                ) : (
                                    renderDefaultMessage()
                                )
                            )}
                        </div>
                    </div>

                </div>

                <Loader isLoading={showLoader} message="Processing..." />
            </section>
        </main>
    );
};

export default DistributorLookupPage;